import { render, staticRenderFns } from "./HistoryPickupTable.vue?vue&type=template&id=442a2772&"
import script from "./HistoryPickupTable.vue?vue&type=script&lang=js&"
export * from "./HistoryPickupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports